import { combineReducers } from "redux";

import utilities from "./utilities/UtilitiesReducer";
import ayucareUsers from "./pages/Users/UsersReducer";
import auth from "./pages/Auth/AuthReducer";
import organisations from "./pages/Organizations/OrganisationsReducer";
import departments from "./pages/Departments/DepartmentsReducer";
import doctors from "./pages/Doctors/DoctorReducer";
import administrators from "./pages/Administrators/AdministratorsReducer";
import patients from "./pages/Patients/PatientsReducer";
import athletes from "./pages/Athletes/PatientReducer";
import cases from "./pages/Cases/CasesReducer";
import newUpdates from "./pages/NewUpdates/NewUpdatesReducer";
import appointments from "./pages/Appointments/AppointmentReducer";
import prescriptions from "./pages/Prescription/PrescriptionReducer";
import headOrgs from "./pages/HeadOrgs/HeadOrgsReducer";
import medicine from "./pages/MedicineList/medicineReducer";
import soapNote from "./pages/soapNote/soapNoteReducer";
import doctorDashboard from "./pages/HomePage/DoctorDashboardReducer";
import followUps from "./pages/Followup/FollowUpsReducer";
export default combineReducers({
  utilities,
  auth,
  ayucareUsers,
  organisations,
  departments,
  doctors,
  administrators,
  patients,
  athletes,
  cases,
  newUpdates,
  appointments,
  prescriptions,
  headOrgs,
  medicine,
  soapNote,
  doctorDashboard,
  followUps,
});
